export const getSsoUrl = () => {
    const hds = window._env_.REACT_APP_HDS_HOST
    const auth = window._env_.REACT_APP_CUR_AUTH_CLBC

    return `${hds}/login?redirect=${auth}`
}

export const isTrackingEnabled = () => window._env_.REACT_APP_TRACKING_ENABLED === 'true'